import { Button, Checkbox, TextField } from "@mui/material";
import React from "react";
import FactoryOne from "../../../assets/paypalOne.png";
import FactoryTwo from "../../../assets/paypal2.png";
import FactoryThree from "../../../assets/factoryIcon.png";
import SizingIcon from "../../../assets/sizingTableIcon.png";
import Placeholder from "../../../assets/placeholder.jpg";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addProduct, getProduct } from "../../../../../api/product";

export default function NewExtraRequestContent({
  product,
  boxShadow,
  option1,
  option2,
  handleOption1Checkbox,
  handleOption2Checkbox,
  setNotes,
  notes,
  payload,
  handleClose,
  request,
  extraRequest,
  productTabValue,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const finalPayload = payload;

  const { id } = useParams();
  const location = useLocation();

  const isProductDetailsPage = () => {
    const path = location.pathname;
    const regex = /^\/customer\/products\/[a-zA-Z0-9]+$/;
    console.log("regex", regex.test(path) && id !== undefined);
    return regex.test(path) && id !== undefined;
  };

  console.log(
    'product?.status === "accepted" && (!option1 && !option2)',
    product,
    option1,
    option2
  );

  return (
    <div>
      <div
        className="usend-dispute-card usend-extra-product"
        style={{
          display: "flex",
          alignItems: "flex-start",
          marginTop: "20px",
          boxShadow: boxShadow,
          padding: "8px 20px",
          borderRadius: "7.5px",
        }}
      >
        <img
          src={(() => {
            if (product?.images?.edges?.length > 0) {
              return product.images.edges[0].node?.url;
            }
            if (product?.images?.length > 0) {
              return product.images[0].src;
            }
            return Placeholder;
          })()}
          alt="productimage"
          style={{ width: "40px", height: "40px", borderRadius: "5px" }}
        />
        <h4 style={{ fontSize: "16px", marginLeft: "20px" }}>
          {product?.title || product?.node?.title || "N/A"}
        </h4>
      </div>
      <label
        className={`usend-dispute-option${option1 ? " is-selected" : ""}`}
        style={{
          cursor: "pointer",
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          boxShadow: boxShadow,
          padding: "20px",
          borderRadius: "7.5px",
          margin: "20px 0px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            textAlign: "left",
          }}
        >
          <div
            className="usend-dispute-glyph"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              marginRight: "20px",
              marginTop: "5px",
            }}
          >
            <img src={FactoryOne} alt="page_image" />
            <img
              src={FactoryTwo}
              alt="page_image"
              style={{ marginTop: -33, marginBottom: "20px" }}
            />
            <img
              src={FactoryThree}
              alt="page_image"
              style={{ marginTop: -45, marginBottom: "20px" }}
            />
          </div>
          <div>
            <h4 style={{ fontSize: "16px", lineHeight: 1.5 }}>
              Factory product pictures
            </h4>
            <h6 style={{ marginTop: 10, marginBottom: 0 }}>
              Get factory product pictures to see how the product looks.
            </h6>
          </div>
        </div>
        <Checkbox
          sx={{
            margin: "0 11px 0 0",
            "&.Mui-checked": { color: "#7f56d9" },
            "&.MuiCheckbox-root": {
              color: "#7f56d9",
            },
          }}
          checked={option1}
          onChange={handleOption1Checkbox}
          name="Sizing table"
        />
      </label>
      <label
        className={`usend-dispute-option${option2 ? " is-selected" : ""}`}
        style={{
          cursor: "pointer",
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          boxShadow: boxShadow,
          padding: "20px",
          borderRadius: "7.5px",
          margin: "20px 0px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            textAlign: "left",
          }}
        >
          <div
            className="usend-dispute-glyph"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              marginRight: "20px",
              marginTop: "5px",
            }}
          >
            <img src={FactoryOne} alt="page_image" />
            <img
              src={FactoryTwo}
              alt="page_image"
              style={{ marginTop: -33, marginBottom: "20px" }}
            />
            <img
              src={SizingIcon}
              alt="page_image"
              style={{ marginTop: -45, marginBottom: "20px" }}
            />
          </div>
          <div>
            <h4 style={{ fontSize: "16px", lineHeight: 1.5 }}>Sizing table</h4>
            <h6 style={{ marginTop: 10, marginBottom: 0 }}>
              Get a sizing table to see if the sizing is applicable to your
              target audience.
            </h6>
          </div>
        </div>
        <Checkbox
          sx={{
            margin: "0 11px 0 0",
            "&.Mui-checked": { color: "#7f56d9" },
            "&.MuiCheckbox-root": {
              color: "#7f56d9",
            },
          }}
          checked={option2}
          onChange={handleOption2Checkbox}
          name="Sizing table"
        />
      </label>

      <TextField
        placeholder="Write your notes or a question..."
        multiline
        minRows={4}
        onChange={(e) => {
          setNotes(e.target.value);
        }}
        value={notes}
        sx={{ width: "100%" }}
      />
      <h6 className="usend-extra-note" style={{ textAlign: "left" }}>
        It can take our team up to 48 hours to add additional information.
      </h6>

      <div className="usend-dispute-actions usend-extra-actions" style={{ textAlign: "right" }}>
        <Button
          variant="lightblue"
          sx={{
            width: "auto",
            marginBottom: 0,
            background: "#210C43",
            boxShadow: "none",
            ":hover": {
              background: "#210C43",
            },
          }}
          disabled={
            ((product?.status === "accepted" ||
              product?.quotation_status === "accepted") &&
              !option1 &&
              !option2) ||
            (product?.status === "pending" && !option1 && !option2)
          }
          // onClick={() => dispatch(addProduct(product))}
          onClick={() => {
            dispatch(addProduct(finalPayload)).then(() => {
              if (request || extraRequest) {
                dispatch(
                  getProduct({
                    status:
                      productTabValue === 0
                        ? "pending"
                        : productTabValue === 1
                        ? "accepted"
                        : productTabValue === 2
                        ? "requote"
                        : productTabValue === 4
                        ? "quality_requote"
                        : "failed",
                  })
                );
              }
              if (!extraRequest || isProductDetailsPage()) {
                navigate(-1);
              }
            });
            handleClose();
          }}
        >
          Request
        </Button>
      </div>
    </div>
  );
}
